import { isNullOrUndefined } from 'Util/TypeGuards';

interface ICargoTypeForCheckInDto {
	id: string;
	cargoMake: string;
	cargoModel: string;
	minimumLengthId: string;
	minimumWeightId: string;
	minimumWidthId?: string;
	characteristicIds: string[];
}

export class CargoTypeForCheckInDto implements ICargoTypeForCheckInDto {
	id: string;
	cargoMake: string;
	cargoModel: string;
	minimumLengthId: string;
	minimumWeightId: string;
	minimumWidthId?: string;
	characteristicIds: string[];

	public constructor(attributes?: Partial<ICargoTypeForCheckInDto>) {
		this.assignAttributes(attributes);
	}

	private assignAttributes(attributes?: Partial<ICargoTypeForCheckInDto>) {
		if (isNullOrUndefined(attributes)) {
			return;
		}
		if (attributes.id !== undefined) {
			this.id = attributes.id;
		}
		if (attributes.cargoMake !== undefined) {
			this.cargoMake = attributes.cargoMake;
		}
		if (attributes.cargoModel !== undefined) {
			this.cargoModel = attributes.cargoModel;
		}
		if (attributes.minimumLengthId !== undefined) {
			this.minimumLengthId = attributes.minimumLengthId;
		}
		if (attributes.minimumWeightId !== undefined) {
			this.minimumWeightId = attributes.minimumWeightId;
		}
		if (attributes.minimumWidthId !== undefined) {
			this.minimumWidthId = attributes.minimumWidthId;
		}
		if (attributes.characteristicIds !== undefined && Array.isArray(attributes.characteristicIds)) {
			this.characteristicIds = attributes.characteristicIds;
		}
	}
}
